import MovePorduct from './MoveProductModal';

export default MovePorduct;
